import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import termsData from '../../data/terms.json';
import './TermsAndConditions.css';

function TermsAndConditions() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Data is imported directly from JSON, but we keep loading state for consistency
    setData(termsData);
    setLoading(false);
  }, []);

  if (loading || !data) {
    return (
      <div className="legal-page">
        <div className="legal-container">
          <div className="legal-content">
            <div className="loading">Loading terms...</div>
          </div>
        </div>
      </div>
    );
  }

  const { header, sections, footer } = data;

  return (
    <div className="legal-page">
      <div className="legal-container">
        <header className="legal-header">
          <div className="legal-logo">
            <img src="/image/Logo.png" alt="AI LeadGen Logo" />
          </div>
          <h1>{header.title}</h1>
          <p className="legal-last-updated">Last updated: {header.lastUpdated}</p>
        </header>

        <main className="legal-content">
          {sections.map((section, index) => (
            <section key={section.id || index} className="legal-section">
              <h2>{section.title}</h2>
              {section.content.map((item, itemIndex) => {
                switch (item.type) {
                  case 'paragraph':
                    return <p key={itemIndex}>{item.text}</p>;
                  case 'list':
                    return (
                      <ul key={itemIndex}>
                        {item.items.map((listItem, liIndex) => (
                          <li key={liIndex}>{listItem}</li>
                        ))}
                      </ul>
                    );
                  case 'subheading':
                    return <h3 key={itemIndex}>{item.text}</h3>;
                  case 'address':
                    return (
                      <address key={itemIndex}>
                        {item.lines.map((line, lineIndex) => (
                          <p key={lineIndex}>{line}</p>
                        ))}
                      </address>
                    );
                  default:
                    return null;
                }
              })}
            </section>
          ))}
        </main>

        <footer className="legal-footer">
          <p>&copy; {new Date().getFullYear()} {footer.copyright}</p>
          <nav>
            {footer.links.map((link, index) => (
              <React.Fragment key={index}>
                <Link to={link.href}>{link.text}</Link>
                {index < footer.links.length - 1 && <span className="separator">|</span>}
              </React.Fragment>
            ))}
          </nav>
        </footer>
      </div>
    </div>
  );
}

export default TermsAndConditions;